import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { API_ENDPOINT } from '../../config'
import ElectionContext from '../../context/ElectionContext'
import useData from '../../hooks/useData'
import { featuredCandidates, raceLevel } from '../../util'
import Error from '../Error'
import Loading from '../Loading'
import RaceFull from '../RaceFull'

const RaceVideo = () => {
  const params = useParams()
  const context = useContext(ElectionContext)
  const data = useData(
    `${API_ENDPOINT}/${context.date}/races/${params.id}`,
    30000
  )

  if (data === undefined) {
    return <Loading />
  } else if (typeof data === 'string') {
    return <Error err={data} />
  }

  return (
    <RaceFull
      {...data.race}
      candidates={featuredCandidates(data.race)}
      shortPartyNames
      level={raceLevel(data.race)}
    />
  )
}

export default RaceVideo
